import React from 'react';
import styled from 'styled-components/macro';
import { translations } from '../../../../locales/translations';
import { useTranslation } from 'react-i18next';
import { InputLabel } from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

export function FromToDatePicker(props) {
  const { label, fromValue, fromValueChange, toValue, toValueChange, disabled } = props;
  const { t } = useTranslation();

  return (
    <Wrapper>
      <div className="date-picker-provider">
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <InputLabel className="input-label date-picker-label">
            {t(label)}
          </InputLabel>
          <KeyboardDatePicker
            value={fromValue}
            onChange={fromValueChange}
            format="yyyy/MM/dd"
            placeholder="YYYY/MM/DD"
            disabled={disabled}
            maxDate={toValue ? new Date(toValue) : new Date()}
            clearable
            minDateMessage=""
            maxDateMessage=""
            invalidDateMessage="Input date is invalid."
          />
        </MuiPickersUtilsProvider>
      </div>
      <div className="to-label">
        {/* {t(translations.contractDetail.amendment.waiver.periodTo)} */}
        {' - '}
      </div>
      <div className="date-picker-provider no-label-padding">
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            value={toValue}
            onChange={toValueChange}
            minDate={fromValue ? new Date(fromValue) : new Date('1970/01/01')}
            format="yyyy/MM/dd"
            placeholder="YYYY/MM/DD"
            disabled={disabled}
            maxDate={new Date()}
            clearable
            minDateMessage="Invalid date range"
            maxDateMessage="Invalid date range"
            invalidDateMessage="Input date is invalid"
          />
        </MuiPickersUtilsProvider>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  margin-right: 5px;
  .date-picker-provider {
    margin-right: 5px;
    .date-picker-label {
      margin-bottom: 4px;
      margin-top: 2px;
    }
    .MuiInputBase-input {
      font-size: 12px;
    }
  }
  .to-label {
    display: flex;
    align-items: center;
    margin-left: 5px;
    padding-top: 15px;
    margin-right: 10px;
  }
  .no-label-padding {
    padding-top: 18px;
  }
`;
